import { useState, useEffect } from "react";
import Cookies from "js-cookie";

type UnityStatus = "NotEligible" | "InExperience" | "OptedOut";

export function useUnityStatusCookie() {
  const [status, setStatus] = useState<UnityStatus | null>(() => {
    return (Cookies.get("UnityStatus") as UnityStatus) || null;
  });

  const updateStatus = (newStatus: UnityStatus) => {
    Cookies.set("UnityStatus", newStatus, {
      expires: 30,
      secure: true,
      sameSite: "lax",
      domain: ".shi.com",
    });
    setStatus(newStatus);
  };

  const clearStatus = () => {
    Cookies.remove("UnityStatus", { domain: ".shi.com" });
    setStatus(null);
  };

  const refreshStatus = () => {
    const currentCookie = (Cookies.get("UnityStatus") as UnityStatus) || null;
    setStatus(currentCookie);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshStatus();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  return { status, updateStatus, clearStatus };
}
